import { Injectable, OnDestroy } from '@angular/core';
import { StepMenuComponent } from './step-menu.component';
import { Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StepMenuPresenter<T> implements OnDestroy {
  view!: StepMenuComponent<T>;

  private destroy$ = new Subject<void>();

  constructor() {}

  setView(view: StepMenuComponent<T>): void {
    this.view = view;
    this.suscribeObservers();
  }

  suscribeObservers(): void {
    // // this.stepMenuService.instances$
    // //   .pipe(takeUntil(this.destroy$))
    // //   .subscribe((instances) =>
    // //     instances.map((instance, i) => {
    // //       if (!instance.formGroup.valid) this.view.activeStep = i;
    // //     })
    //  // );

    this.view.stepChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe((step) =>{
        this.view.activeStep = step
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  findNextStepAvailable(currentStep: number): number {
    let step = currentStep+1
    while((this.view.routeItems[step]?.disabled ?? false)){
      if (step >= this.view.routeItems.length) {
        step = this.view.routeItems.length -1;
        break
      };
      step++;
    }
    return step;
  }

  findPrevStepAvailable(currentStep: number): number {
    let step = currentStep-1
    while((this.view.routeItems[step]?.disabled ?? false)){
      if (step < 0) {
        step = 0;
        break
      };
      step--;
    }
    return step;
  }

  onStepChange(step: number): void {
    if (step === this.view.lastStep) return;

    this.view.lastStep = step;
    this.view.activeStep = step;
    this.view.activeItemChange.emit(this.view.routeItems[step]);
  }

  updateStepMenu(tabMenuName: string, disable: boolean): void {
    const routeItem = this.view.routeItems.find(
      (route) => route.label === tabMenuName
    );

    if (routeItem) routeItem.disabled = disable;
  }
}
